import React from "react";
import { Consume } from "../Context/Consumer";
import {
  WebConfigDataContext,
  ConstraintsContext,
  TransContext,
  FixturesContext,
  CompositionContext,
  PlayerListContext,
  PlayerRecommendationContext,
  TeamDataContext,
  GamedaysContext,
  LoginContext,
  GeolocationUrlContext,
  MixApiContext,
  LiveScoringContext,
  GamerCardContext,
} from "../Context";
import {
  PlayerDetailTogglerProvider,
  ShowToastProvider,
  ShowPopUpProvider,
} from "../Context/Providers";
import config from "../common/config";
import {
  makeClasses,
  detechChromeBrowser,
  getIsPlyListEdit,
  hasTeam,
  getMatchdayNode,
  setGameModeOnFixtures,
  getCurrMatchForPlayerList,
  getUserProfile,
  getLoginCookie,
  makeManageTeamSkeleton,
  setLocalStorage,
  getParams,
  getQueryParamsObject,
  getData,
  getLocalStorage,
  isWebView,
  isLocation,
  checkForAnyGamedayLive,
  getGamedayStatus,
  getTrans,
} from "../common/index";
import Routes from "./Routes";
import { isEmpty } from "lodash";
import {
  BrowserRouter,
  Switch,
  Route,
  Redirect,
  withRouter,
} from "react-router-dom";
import Menu from "./menu";
import LoginPopup from "./loginPopup";
import Loader from "./Loader";
import Cookies from "./Cookies";
import ToastMsg from "./toastMsg";
import Maintainance from "./maintainance";
let matchLandingIntervalCount = null;
let liveScoringIntervalCount = null;

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      callInitiated: false,
      isCheckedForLoginParams: false,
      isUserRegistered: false,
      objShowHideToast: { isShow: false },
      inMaintainenace: false,
    };
  }

  componentDidMount() {
    let self = this;
    //make all api calls and gh component
    // and pass functions to gh component so that callback is recived and card is loaded
    let loginCookie = getLoginCookie();

    self.props.WebConfigData.getwebConfig(
      {},
      (response) => {
        // console.log("came here getwebConfig")
        self.props.WebConfigData.setwebConfig(response);
        self.props.GeolocationUrlData.getGeoLocationUrlData(
          {},
          (resp) => {},
          (err) => {}
        );
        self.props.TransData.getTrans(
          {},
          (response) => {},
          () => {}
        );
        if (loginCookie && loginCookie.IsRegistered) {
          if (self.props.loginData.userProfile === null) {
            self.props.loginData.getUserProfileData(
              { language: config.language },
              () => {}
            );
          }
        }

        if (!isWebView()) {
          self.callIntervalForMixAPI(true);
        }
      },
      () => {}
    );
  }

  init = (propsP, isInitialCall, isBack) => {
    let self = this;
    let loginCookie = getLoginCookie();
    self.props.MixApiData.getMixApiData(
      {},
      (resp) => {
        // if (propsP?.MixApiData?.data?.ismaintenance === "1") {
        let screenMode = self.props.FixturesData.screenMode;
        let isEditing =
          screenMode == config.screenMode.transfer ||
          screenMode == config.screenMode.substitution;
        let {
          cnstrnts: constraintsVersion,
          fix: fixturesVersion,
          plyrs: playersVersion,
        } = resp;
        let constraintsCurrVersion =
          localStorage.getItem(`_buster_/constraints`);
        let fixtureCurrVersion = localStorage.getItem(`_buster_/fixtures`);
        let playersCurrVersion = localStorage.getItem(`_buster_/players`);
        if (constraintsCurrVersion != constraintsVersion) {
          localStorage.setItem(`_buster_/constraints`, constraintsVersion);
        }
        if (fixtureCurrVersion != fixturesVersion) {
          localStorage.setItem(`_buster_/fixtures`, fixturesVersion);
        }
        if (playersCurrVersion != playersVersion) {
          localStorage.setItem(`_buster_/players`, playersVersion);
        }

        if (resp?.ismaintenance === "1") {
          this.setState({
            ...this.state,
            inMaintainenace: true,
          });
        } else {
          if (isEditing) {
            let versionTrack = getLocalStorage(
              config.isVersionChangeTrackKey
            ) || [0, 0, 0];
            !versionTrack[0] &&
              (versionTrack[0] = +(
                constraintsCurrVersion != constraintsVersion
              ));
            !versionTrack[1] &&
              (versionTrack[1] = +(fixtureCurrVersion != fixturesVersion));
            // !versionTrack[2] && // commented
            //   (versionTrack[2] = +(playersCurrVersion != playersVersion));
            setLocalStorage(config.isVersionChangeTrackKey, versionTrack);
            return false;
          }
          if (
            isInitialCall ||
            propsP.MixApiData.data.cnstrnts !==
              self.props.MixApiData.data.cnstrnts
          ) {
            self.props.ConstraintsData.getConstraints(
              { v: self.props.MixApiData.data.cnstrnts },
              (response) => {
                config.phaseId = response.PhaseId;
                self.props.CompositionData.getComposition(
                  {},
                  () => {},
                  () => {}
                );
                self.fixturesCall(response, true, isInitialCall);
              },
              () => {}
            );
          } else {
            if (propsP.MixApiData.data.fix !== self.props.MixApiData.data.fix) {
              self.fixturesCall(
                self.props.ConstraintsData.data,
                propsP.MixApiData.data.plyrs !==
                  self.props.MixApiData.data.plyrs
                  ? true
                  : false,
                isInitialCall
              );
            }
            if (
              propsP.MixApiData.data.plyrs !== self.props.MixApiData.data.plyrs
            ) {
              self.callPlayerlist(self.props.ConstraintsData.data.GamedayId);
            }
          }
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };
  callPlayerlist = (gamedayId) => {
    let self = this;
    self.props.PlayerListData.getPlayerList(
      {
        v: self.props.MixApiData.data.plyrs,
        gamedayId: gamedayId,
      },
      () => {},
      () => {}
    );
  };

  fixturesCall = (response, isPlayerListCall, isInitialCall) => {
    let self = this;
    let loginCookie = getLoginCookie();
    const prevAnyGamedayLive = checkForAnyGamedayLive(
      self.props.FixturesData?.data
    );
    self.props.FixturesData.getFixtures(
      { v: self.props.MixApiData.data.fix },
      (resp) => {
        const currAnyGamedayLive = checkForAnyGamedayLive(resp);
        currAnyGamedayLive
          ? self.callIntervalForLiveScoring(isInitialCall)
          : self.clearLiveScoringInterval();
        isPlayerListCall && self.callPlayerlist(response.GamedayId);
        isInitialCall && self.checkForLoginQueryParams();
        if (loginCookie) {
          self.props.Gamedays.makeGamedaysCall(
            {},
            (res) => {
              if (res?.Meta?.RetVal === 1) {
                self.props.Gamedays.setIsGamedaysCalled(true);
                let userPlayerdGamedayIds = res.Data.Value.Gamedays;
                let fix = resp.find((a) => {
                  return (
                    a.GDIsCurrent === 1 &&
                    a.GDIsLocked === 1 &&
                    userPlayerdGamedayIds.find((b) => {
                      return b.GamedayId === a.GamedayId;
                    })?.GamedayId
                  );
                });
                if (!fix?.GamedayId) {
                  fix = resp.find((a) => {
                    return (
                      a.GamedayId ===
                      res?.Data?.Value?.CurrentGameday?.CurrentGamedayId
                    );
                  });
                }
                let currentMatchDay = fix;
                self.props.FixturesData.setCurrMatchDay(currentMatchDay);
                self.props.FixturesData.setCurrMatchDayDefault(currentMatchDay);
                if (userPlayerdGamedayIds.length) {
                  let params = {
                    optType: config.optType,
                    gamedayId: fix.GamedayId,
                    phaseId: config.phaseId,
                    language: config.language,
                  };
                  self.props.Gamedays.getSelectedTeam(
                    params,
                    (response) => {
                      let mode = getGamedayStatus(fix);
                      self.props.FixturesData.setGameMode(mode);
                      let teamDataSkeleton = makeManageTeamSkeleton(
                        response?.Data?.Value,
                        self.props.PlayerListData.rawPlayerList,
                        self.props.CompositionData.data
                      );
                      self.props.TeamData.setTeamData(
                        teamDataSkeleton.teamData
                      );

                      if (mode === config.modes.live) {
                        self.props.TeamData.setLiveTeamData(
                          teamDataSkeleton.teamData
                        );
                      }
                    },
                    () => {}
                  );
                } else {
                  self.props.FixturesData.setScreenMode(
                    config.screenMode["create-team"]
                  );
                  self.props.FixturesData.setGameMode(config.modes.transfer);
                }
                if (!isInitialCall) {
                  self.props.GamerCard.getGameCard(
                    {
                      optTye: config.optType,
                      platformId: loginCookie ? loginCookie.PlatformId : 0,
                      clientId: loginCookie ? loginCookie.ClientId : 1,
                    },
                    () => {}
                  );
                }
              }
            },
            (error) => {
              console.log(error);
            }
          );
        } else {
          if (!isInitialCall) {
            if (
              prevAnyGamedayLive != currAnyGamedayLive
              // &&
              // window.currentPage == "/"
            ) {
              self.props.GamerCard.getGameCard(
                {
                  optTye: config.optType,
                  platformId: loginCookie ? loginCookie.PlatformId : 0,
                  clientId: loginCookie ? loginCookie.ClientId : 1,
                },
                () => {}
              );
            }
          }
        }

        //set current fixtures
      },
      () => {}
    );
  };

  clearLiveScoringInterval = () => {
    let self = this;
    self.props.LiveScoringData.setScoring(null);
    window.clearInterval(liveScoringIntervalCount);
  };

  makeUserGamedaysCall = () => {
    let self = this;
    self.props.Gamedays.makeGamedaysCall(
      {},
      (res) => {
        if (res?.Meta?.RetVal === 1) {
          self.props.Gamedays.setIsGamedaysCalled(true);
          let userPlayerdGamedayIds = res.Data.Value.Gamedays;
          let fix = self.props.FixturesData.data.find((a) => {
            return (
              a.GDIsCurrent === 1 &&
              a.GDIsLocked === 1 &&
              userPlayerdGamedayIds.find((b) => {
                return b.GamedayId === a.GamedayId;
              })?.GamedayId
            );
          });
          if (!fix?.GamedayId) {
            fix = self.props.FixturesData.data.find((a) => {
              return (
                a.GamedayId ===
                res?.Data?.Value?.CurrentGameday?.CurrentGamedayId
              );
            });
          }
          let currentMatchDay = fix;
          self.props.FixturesData.setCurrMatchDay(currentMatchDay);
          self.props.FixturesData.setCurrMatchDayDefault(currentMatchDay);
          if (userPlayerdGamedayIds.length) {
            let params = {
              optType: config.optType,
              gamedayId: fix.GamedayId,
              phaseId: config.phaseId,
              language: config.language,
            };
            self.props.Gamedays.getSelectedTeam(
              params,
              (response) => {
                let mode = getGamedayStatus(fix);
                self.props.FixturesData.setGameMode(mode);
                let teamDataSkeleton = makeManageTeamSkeleton(
                  response?.Data?.Value,
                  self.props.PlayerListData.rawPlayerList,
                  self.props.CompositionData.data
                );
                self.props.TeamData.setTeamData(teamDataSkeleton.teamData);

                if (mode === config.modes.live) {
                  self.props.TeamData.setLiveTeamData(
                    teamDataSkeleton.teamData
                  );
                }
              },
              () => {}
            );
          } else {
            self.props.FixturesData.setScreenMode(
              config.screenMode["create-team"]
            );
            self.props.FixturesData.setGameMode(config.modes.transfer);
          }
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };
  checkForLoginQueryParams = (callback) => {
    let self = this;
    let paramsObj = getQueryParamsObject();
    let loginCookie = getLoginCookie();
    let connectingSocial = getLocalStorage("setCustomSocial");

    if (
      loginCookie &&
      loginCookie?.ClientId == 5 &&
      self.props.loginData?.userProfile?.isemlvrf === 0
    ) {
      window.history.replaceState(null, null, window.location.pathname);
      self.props.loginData.setObjShowHideLogin({
        screenMode: config.loginScreenMode.linkNewLogin,
      });
      self.props.loginData.setUserData({
        emailId: loginCookie?.emailId,
      });
      self.props.loginData.setIsShowLoginPopup(true);
      self.setState({
        isCheckedForLoginParams: true,
      });
    }

    let param =
      window.location.pathname.indexOf("leagues") > -1
        ? window.location.pathname
            .replace(`${config.BASE_DOMAIN_LANG}leagues`, "")
            .split("/")
        : "";
    if (param) {
      param.shift();
      setLocalStorage("lgCod", param[0]);
      setLocalStorage("lgNam", param[1]);
      setLocalStorage("UsrNam", param[2]);
    }

    if (
      (!isEmpty(paramsObj) && !loginCookie && paramsObj.AccessToken) ||
      (loginCookie && !loginCookie.IsRegistered)
    ) {
      let params = {
        clientId: paramsObj.ClientId,
        accessToken: paramsObj.AccessToken,
        oAuthVerification: paramsObj.OAuthVerification,
        platformId: paramsObj.PlatformId ? paramsObj.PlatformId : 1,
      };
      self.props.loginData.makeSocialLogin(
        params,
        (resp) => {
          console.log(resp);
          window.history.replaceState(null, null, window.location.pathname);
          self.makeUserGamedaysCall();
          self.setState({
            isCheckedForLoginParams: true,
            isUserRegistered: true,
          });
          let leagueCode = getLocalStorage("lgCod");
          let leagueName = getLocalStorage("lgNam");
          let userName = getLocalStorage("UsrNam");
          if (leagueCode && leagueName && userName) {
            setLocalStorage("lgCod", "");
            setLocalStorage("lgNam", "");
            setLocalStorage("UsrNam", "");
            window.location.replace(
              config.BASE_DOMAIN_LANG +
                `leagues/${leagueCode}/${leagueName}/${userName}`
            );
          }
        },
        (error) => {
          let retVal = error.RetVal;
          console.log(error);
          if (retVal === 2) {
            window.history.replaceState(null, null, window.location.pathname);
            self.props.loginData.setObjShowHideLogin({
              screenMode: config.loginScreenMode.register,
            });
            self.props.loginData.setIsShowLoginPopup(true);
            self.setState({
              isCheckedForLoginParams: true,
            });
          } else if (retVal === 2001) {
            window.history.replaceState(null, null, window.location.pathname);
            self.props.loginData.setObjShowHideLogin({
              screenMode: config.loginScreenMode.linkAccounts,
            });
            self.props.loginData.setIsShowLoginPopup(true);
            self.setState({
              isCheckedForLoginParams: true,
            });
          } else if (retVal === 10001 || retVal === 2002) {
            let showSecond = retVal === 2002 ? true : false;
            window.history.replaceState(null, null, window.location.pathname);
            self.props.loginData.setObjShowHideLogin({
              isRetVal: showSecond,
              screenMode: config.loginScreenMode.emailProtected,
              clientId: paramsObj.ClientId,
            });
            self.props.loginData.setIsShowLoginPopup(true);
            self.setState({
              isCheckedForLoginParams: true,
            });
          }
        }
      );
    } else {
      paramsObj.AccessToken === "" &&
        window.history.replaceState(null, null, window.location.pathname);
      self.setState({
        isCheckedForLoginParams: true,
      });
    }

    if (connectingSocial) {
      self.props.loginData.connectingSocialLogin(
        {
          clientId: paramsObj.ClientId,
          accessToken: paramsObj.AccessToken,
          oAuthVerification: paramsObj.OAuthVerification,
          platformId: paramsObj.PlatformId ? paramsObj.PlatformId : 1,
        },
        (resp) => {
          console.log(resp);
          self.props.loginData.getUserProfileData(
            { language: config.language },
            () => {}
          );
          window.history.replaceState(null, null, window.location.pathname);
          self.makeUserGamedaysCall();
          self.props.loginData.setIsShowLoginPopup(false);
          self.showHideToast(
            true,
            getTrans(
              self.props.TransData.data,
              "auth_v2_account_link_success_msg",
              "Account linked Successfully"
            ),
            false
          );
          self.setState({
            isCheckedForLoginParams: true,
            isUserRegistered: true,
          });
          let leagueCode = getLocalStorage("lgCod");
          let leagueName = getLocalStorage("lgNam");
          let userName = getLocalStorage("UsrNam");
          if (leagueCode && leagueName && userName) {
            setLocalStorage("lgCod", "");
            setLocalStorage("lgNam", "");
            setLocalStorage("UsrNam", "");
            window.location.replace(
              config.BASE_DOMAIN_LANG +
                `leagues/${leagueCode}/${leagueName}/${userName}`
            );
          }
        },
        (error) => {
          console.log(error);
          let retVal = error.RetVal;
          if (retVal === 10001) {
            window.history.replaceState(null, null, window.location.pathname);
            self.props.loginData.setObjShowHideLogin({
              isRetVal: false,
              screenMode: config.loginScreenMode.emailProtected,
              clientId: paramsObj.ClientId,
            });
            self.props.loginData.setIsShowLoginPopup(true);
            self.setState({
              isCheckedForLoginParams: true,
            });
          } else if (retVal === 1006 || retVal === 1011) {
            self.props.loginData.setIsShowLoginPopup(false);
            self.props.loginData.makeLogoutCall({ isReload: true });
            self.props.loginData.setObjShowHideLogin({
              screenMode: config.loginScreenMode.main,
            });
          } else if (retVal === 1004) {
            self.props.loginData.setIsShowLoginPopup(false);
            self.props.loginData.makeLogoutCall({ isReload: false });
            self.props.loginData.setObjShowHideLogin({
              screenMode: config.loginScreenMode.main,
            });
            self.showHideToast(
              true,
              getTrans(
                self.props.TransData.data,
                "User_not_found",
                "User not found"
              ),
              true
            );
          } else if (retVal === 2003) {
            let msg = getTrans(
              self.props.TransData.data,
              "auth_v2_unable_to_link_c_custom_2003_msg",
              "Social Id mis matched for {{email_id}}"
            ).replace("{{email_id}}", loginCookie.EmailId);
            self.showHideToast(true, msg, true);
          } else if (retVal === 2021) {
            let msg = getTrans(
              self.props.TransData.data,
              "auth_v2_unable_to_link_c_social_2021_msg",
              "This {{client_id}} account is associated with another account."
            ).replace(
              "{{client_id}}",
              getTrans(
                self.props.TransData.data,
                config.enumClientIdName[loginCookie.ClientId]
              )
            );
            self.showHideToast(true, msg, true);
          }
        }
      );
      setLocalStorage("setCustomSocial", false);
    }
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      config.WebConfig &&
      nextProps.ConstraintsData.data &&
      nextProps.TransData.data &&
      nextProps.FixturesData.data &&
      nextProps.CompositionData.data &&
      !nextProps.PlayerListData.data &&
      !prevState.callInitiated
    ) {
      // console.log("came here")

      let loginCookie = getLoginCookie();
      //check the code of userplayed game days here

      if (!loginCookie) {
        nextProps.FixturesData.setScreenMode(config.screenMode["create-team"]);
        nextProps.FixturesData.setGameMode(config.modes.transfer);
      }

      prevState.callInitiated = true;
      return prevState;
    }
    return null;
  }

  clearPageInterval() {
    window.clearInterval(matchLandingIntervalCount);
    window.clearInterval(liveScoringIntervalCount);
  }

  callIntervalForMixAPI = (isInitialCall, isBack) => {
    const self = this;
    this.clearPageInterval();
    self.init(null, isInitialCall, isBack);

    matchLandingIntervalCount = window.setInterval(function () {
      self.init(self.props, false, false);
    }, config.mixApiLiveInterval);
  };

  callIntervalForLiveScoring = (isInitialCall) => {
    let self = this;
    /* if (isInitialCall) { */
    self.props.LiveScoringData.getLiveScoring(
      self.props.TeamData?.data,
      "live",
      (resp) => {
        console.log(resp);
      }
    );
    liveScoringIntervalCount = window.setInterval(function () {
      self.props.LiveScoringData.getLiveScoring(
        self.props.TeamData?.data,
        "live",
        (resp) => {
          console.log(resp);
        }
      );
    }, config.liveScoringInterval);
    /* } */
  };

  goAhead() {
    let loginCookie = getLoginCookie();
    if (!isWebView()) {
      if (
        this.props.GeolocationUrlData.geolocationdata &&
        this.props.PlayerListData &&
        this.props.PlayerListData.data &&
        (this.props.PlayerListData.data.length ||
          this.props.PlayerListData.PlayerListCalledFlag) &&
        this.props.CompositionData &&
        this.props.CompositionData.TeamListContextData &&
        this.state.isCheckedForLoginParams &&
        (loginCookie
          ? this.props.Gamedays.currGameday &&
            (this.props.Gamedays.data?.length
              ? this.props.Gamedays.selectedTeam && this.props.TeamData.data
              : true)
          : true)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        this.props.GeolocationUrlData.geolocationdata &&
        this.props.TransData.data
      ) {
        return true;
      } else {
        return false;
      }
    }
  }

  showHideToast = (isShow, msg, isWarning) => {
    let self = this;
    self.setState({
      objShowHideToast: {
        isShow: isShow,
        msg: msg,
        isWarning: isWarning,
      },
    });
  };

  render() {
    let self = this;
    const goAhead = self.goAhead();
    let { isShowLoginPopup } = this.props.loginData;
    let gdprValue = getLocalStorage("setGDPR");
    let propsLoginPopup = {
      isShowLoginPopup,
      showHideToast: self.showHideToast,
    };
    let propsToastMsg = {
      objShowHideToast: self.state.objShowHideToast,
      showHideToast: self.showHideToast,
    };
    return (
      <PlayerDetailTogglerProvider>
        <ShowToastProvider>
          <ShowPopUpProvider>
            <div className="si-main">
              {goAhead && !this.state.inMaintainenace ? (
                <>
                  {!isWebView() ? <Menu /> : null}
                  {!gdprValue &&
                  !isWebView() &&
                  isLocation(
                    config.enumContinentList.Europe,
                    this.props.GeolocationUrlData.geolocationdata
                  ) ? (
                    <Cookies />
                  ) : null}
                  <Routes />
                </>
              ) : this.state.inMaintainenace ? (
                <Maintainance />
              ) : (
                <Loader />
              )}
              {isShowLoginPopup ? <LoginPopup {...propsLoginPopup} /> : null}
              {self.state.objShowHideToast.isShow ? (
                <ToastMsg {...propsToastMsg} />
              ) : null}
            </div>
          </ShowPopUpProvider>
        </ShowToastProvider>
      </PlayerDetailTogglerProvider>
    );
  }
}

export default withRouter(
  Consume(Main, [
    WebConfigDataContext,
    ConstraintsContext,
    TransContext,
    FixturesContext,
    CompositionContext,
    PlayerListContext,
    PlayerRecommendationContext,
    TeamDataContext,
    GamedaysContext,
    LoginContext,
    LoginContext,
    GeolocationUrlContext,
    MixApiContext,
    LiveScoringContext,
    GamerCardContext,
  ])
);
